var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"couponsConfig"},[_c('form-combination',{ref:"formName",attrs:{"form-data":_vm.formData}}),_c('div',{staticClass:"button"},[_c('el-button',{on:{"click":_vm.close}},[_vm._v("取消")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.confirm}},[_vm._v("确定")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }